import { createAction } from 'redux-starter-kit';
import { post, get } from '../../../../utility/via-fetch';
import { requestStart, requestSucceded, requestFailed } from '../../../domain/requests/RequestActions';
import { addNotification, addMessage } from '../../application/messageUiActions';
import { putUser } from '../../../domain/users/userActions';
import { setSessionUser } from '../../application/sessionUiActions';
import routeLocations from '../../../../utility/route-locations';

/*
 * An action that signifies a request to set users password
 */
export const resetPassword = createAction('RESET_PASSWORD');


/*
 * A action that send and password reset request token to the server to check prove the users email is verified and to give them a new password.
 * @param {string} requestToken should be /reset-password/{HrxadecimalToken}
 * @param {string} password The users new password.
 * @param {history} history The history form the router to allow loading a new page on success
 */
export function requestResetPassword(requestToken, password, history) {
  return async (dispatch) => {
    const requestId = dispatch(requestStart(resetPassword.toString()));
    dispatch(resetPassword(requestId));
    try {
      const user = await post(`/api/users/reset-password${requestToken}`, undefined, { value: password });
      dispatch(addMessage('success', 'passwordSaved'));
      // sign them in.
      dispatch(setSessionUser(user.userId));
      dispatch(putUser(user));
      history.push(routeLocations.dashboard);
      dispatch(requestSucceded(requestId));
    } catch (error) {
      dispatch(requestFailed(requestId, error)); // We failed.
    }
  };
}

/*
 * An action that signifies a request to set users password
 */
export const fetchChangePassword = createAction('CHANGE_PASSWORD');


/**
 * Changes the users password to the new password
 *
 */
export function requestChangePassword(currentPassword, newPassword, displayNotification) {
  return async (dispatch) => {
    const requestId = dispatch(requestStart(fetchChangePassword.toString()));
    dispatch(fetchChangePassword(requestId));
    try {
      await post('/api/security/password', undefined, { currentPassword, newPassword });
      dispatch(addMessage('success', 'passwordSaved'));
      if (displayNotification) {
        dispatch(addNotification('info', null, 'confirmOnApp', {}, 'confirmOnAppDesc'));
      }
      dispatch(requestSucceded(requestId));
    } catch (error) {
      dispatch(requestFailed(requestId, error)); // We failed.
    }
  };
}

/*
 * An action that signifies a request to send a user a reset password email.
 */
export const sendResetPasswordEmail = createAction('SEND_RESET_PASSWORD_EMAIL');


/**
 * A action that sends the user a new reset-password request.
 * @param {string} reCaptcha the token generated by google recaptcha for the user
 * @param {string} username The input email address
 */
export function requestResetPasswordEmail(username, reCaptcha, history) {
  return async (dispatch) => {
    const requestId = dispatch(requestStart(sendResetPasswordEmail.toString()));
    dispatch(sendResetPasswordEmail(requestId));
    try {
      await post(`/api/users/${username}/reset-password`, undefined, { value: reCaptcha });
      dispatch(addMessage('success', 'emailSent', { email: username }));
      history.push(routeLocations.login);
      dispatch(requestSucceded(requestId));
    } catch (error) {
      dispatch(requestFailed(requestId, error)); // We failed.
    }
  };
}


/*
 * An action that signifies a request to load the user for a given request key.
 */
export const loadUnauthUser = createAction('GET_USER_FOR_REQUEST');


/**
 * A action that retrieves user details from the server for the given request
 * Resets the Via state as this should only be called as the first action in a new instance.
 * Sets the session user but does not authorise them.
 * @param {string} requestToken should be a HexadecimalToken}
 */
export function requestUnauthUser(requestToken, failDescId) {
  return async (dispatch) => {
    const requestId = dispatch(requestStart(loadUnauthUser.toString()));
    dispatch(loadUnauthUser(requestId)); // This is called upon page load from an email.
    // The user should have nothing cached and if they do, it's no longer relevant.
    try {
      const requestUser = await get(`/api/users/from-request${requestToken}`, undefined, { });
      dispatch(requestSucceded(requestId, requestUser));
    } catch (error) {
      dispatch(requestFailed(requestId, error)); // We failed.
      // Invalid token message?
      dispatch(addNotification('warning', null, 'invalidLink', [], failDescId, []));
    }
  };
}
